import { render, staticRenderFns } from "./AusbildungsUebersichtsListe.vue?vue&type=template&id=0962dc37"
import script from "./AusbildungsUebersichtsListe.vue?vue&type=script&lang=js"
export * from "./AusbildungsUebersichtsListe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports